// Auto-generated during build - DO NOT EDIT
export const APP_VERSION = '45.0.0';
export const BUILD_HASH = '733071f3c35fa82a';
